import React from 'react';
import { CSpinner } from '@coreui/react';

/**
 * Спінер CoreUI, вирівняний по центру контейнера.
 *
 * @param {object} props
 * @param {string} [props.color='secondary'] — колір спінера (значення CoreUI: `'primary'`, `'success'`, `'danger'` тощо)
 * @returns {JSX.Element}
 *
 * @example
 * <CenterLoader />
 * <CenterLoader color="success" />
 */
export const CenterLoader = ({ color = 'secondary' }) => (
	<div className="d-flex justify-content-center align-items-center py-5">
		<CSpinner color={color} />
	</div>
);

